 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER_PAGE from '@/components/xhtml/00_Cover_Page'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_HALFTITLE_PAGE from '@/components/xhtml/01_Halftitle_Page'
 import XHTML02_FM from '@/components/xhtml/02_Fm'
 import XHTML03_TITLE_PAGE from '@/components/xhtml/03_Title_page'
 import XHTML04_COPYRIGHT from '@/components/xhtml/04_Copyright'
 import XHTML05_DEDICATION from '@/components/xhtml/05_Dedication'
 import XHTML06_CONTENTS from '@/components/xhtml/06_Contents'
 import XHTML07_ACKNOWLEDGMENTS from '@/components/xhtml/07_Acknowledgments'
 import XHTML08_INTRODUCTION from '@/components/xhtml/08_Introduction'
 import XHTML09_CHAPTER_1_PREPARING_THE_SOIL from '@/components/xhtml/09_Chapter_1_Preparing_the_Soil'
 import XHTML10_CHAPTER_2_WEEDS_IN_THE_CROP from '@/components/xhtml/10_Chapter_2_Weeds_in_the_Crop'
 import XHTML11_CHAPTER_3_WIND_AND_HAIL from '@/components/xhtml/11_Chapter_3_Wind_and_Hail'
 import XHTML12_CHAPTER_4_SEEDS_OF_CHANGE from '@/components/xhtml/12_Chapter_4_Seeds_of_Change'
 import XHTML13_CHAPTER_5_DEEPER_ROOTS from '@/components/xhtml/13_Chapter_5_Deeper_Roots'
 import XHTML14_CHAPTER_6_A_NEW_ROAD from '@/components/xhtml/14_Chapter_6_A_New_Road'
 import XHTML15_CHAPTER_7_NEW_GROWTH from '@/components/xhtml/15_Chapter_7_New_Growth'
 import XHTML16_CHAPTER_8_RIPENING from '@/components/xhtml/16_Chapter_8_Ripening'
 import XHTML17_CHAPTER_9_BRANCHING_OUT from '@/components/xhtml/17_Chapter_9_Branching_Out'
 import XHTML18_CHAPTER_10_NURTURING_EACH_OTHER from '@/components/xhtml/18_Chapter_10_Nurturing_Each_Other'
 import XHTML19_PHOTO_COLLECTION_I from '@/components/xhtml/19_Photo_Collection_I'
 import XHTML20_CHAPTER_11_FRUITFULNESS from '@/components/xhtml/20_Chapter_11_Fruitfulness'
 import XHTML21_CHAPTER_12_GROWING_WITH_GRACE from '@/components/xhtml/21_Chapter_12_Growing_With_Grace'
 import XHTML22_CHAPTER_13_NEW_HARVEST from '@/components/xhtml/22_Chapter_13_New_Harvest'
 import XHTML23_CHAPTER_14_PROPAGATION from '@/components/xhtml/23_Chapter_14_Propagation'
 import XHTML24_CHAPTER_15_NURTURING_THE_SEEDLIN from '@/components/xhtml/24_Chapter_15_Nurturing_the_Seedlin'
 import XHTML25_CHAPTER_16_SOME_SOW__OTHERS_REAP from '@/components/xhtml/25_Chapter_16_Some_Sow__Others_Reap'
 import XHTML26_CHAPTER_17_RAIN_AND_SUNSHINE from '@/components/xhtml/26_Chapter_17_Rain_and_Sunshine'
 import XHTML27_CHAPTER_18_STORMS from '@/components/xhtml/27_Chapter_18_Storms'
 import XHTML28_CHAPTER_19_BOUNTIFUL_BLESSINGS from '@/components/xhtml/28_Chapter_19_Bountiful_Blessings'
 import XHTML29_CHAPTER_20_FUTURE_GROWTH from '@/components/xhtml/29_Chapter_20_Future_Growth'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML30_PHOTO_COLLECTION_II from '@/components/xhtml/30_Photo_Collection_II'
 import XHTML31_ABOUT_THE_AUTHORS from '@/components/xhtml/31_About_the_Authors'
 import XHTML32_ENDNOTES from '@/components/xhtml/32_Endnotes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/06_Contents",
 			"name" : "xhtml/06_Contents",
 			"component" : XHTML06_CONTENTS
 		},
 		{
 			"path" : "/xhtml/07_Acknowledgments",
 			"name" : "xhtml/07_Acknowledgments",
 			"component" : XHTML07_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/08_Introduction",
 			"name" : "xhtml/08_Introduction",
 			"component" : XHTML08_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/09_Chapter_1_Preparing_the_Soil",
 			"name" : "xhtml/09_Chapter_1_Preparing_the_Soil",
 			"component" : XHTML09_CHAPTER_1_PREPARING_THE_SOIL
 		},
 		{
 			"path" : "/xhtml/10_Chapter_2_Weeds_in_the_Crop",
 			"name" : "xhtml/10_Chapter_2_Weeds_in_the_Crop",
 			"component" : XHTML10_CHAPTER_2_WEEDS_IN_THE_CROP
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js